export default __webpack_public_path__ + "static/media/RobotoMono-VariableFont_wght.abab8a0b.woff2";